import axios from "axios";
import credentials from "../assets/credentials";
const API_BASE_URL = credentials.BASE_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Automatically add token to requests (if available)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

//api call template for simpler call
async function apiCallTemplate(reqType, callURL, reqBody, file = false) {
  try {
    const response = await apiClient[reqType](callURL, reqBody || null, {
      headers: file
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.status >= 400 && error.response.data.message) {
      throw new Error(error.response?.data?.message);
    } else {
      console.log(error);
      // throw new Error("");
    }
  }
}

export default apiCallTemplate;
